import { useEffect, useState } from 'react';

export const MOBILE_MAP_MEDIA_QUERY = '(max-width: 768px)';

export function useMobileMapLayout(query = MOBILE_MAP_MEDIA_QUERY) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = (event) => setIsMobile(event.matches);
    setIsMobile(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
